<filter-view-layout
	*ngIf="(currentView$ | async) as currentView"
	#foldersContainer>
	<div class="filter-bar" filter-view-filter-bar [hidden]="dataSourceZeroState.hasZeroState && dataSourceZeroState.errorCode !== 0">
		<div [formGroup]="form">
			<div class="filter-container">
				<mat-form-field goSelect>
					<mat-label>{{ 'common_filter-by' | translate }}</mat-label>
					<mat-select
						formControlName="filterBy"
						disableOptionCentering
						panelClass="offsetPanel">
						<mat-option
							*ngFor="let option of filterByOptions"
							[value]="option">
							{{ filterByTranslations[option] | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div class="sort-container">
				<mat-form-field goSelect>
					<mat-label>{{ 'common_sort-by' | translate }}</mat-label>
					<mat-select
						formControlName="sortBy"
						disableOptionCentering
						panelClass="offsetPanel">
						<mat-option
							*ngFor="let option of sortByOptions"
							[value]="option">
							{{ sortByTranslations[option] | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div class="account-container" *ngIf="(instructors$ | async) as instructors">
				<mat-form-field goSelect>
					<mat-label>{{ 'common_account' | translate }}</mat-label>
					<mat-select
						formControlName="instructorId"
						disableOptionCentering
						panelClass="offsetPanel">
						<mat-option
							*ngFor="let instructor of instructors | alphabeticalByKey:'first_name'"
							[value]="instructor.user_id">
							{{ instructor.first_name + ' ' + instructor.last_name }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</div>

	<div class="filter-option" filter-view-options-bar [hidden]="dataSourceZeroState.hasZeroState">
		<button *ngIf="currentView === views.LIST"
			type="button"
			class="icon-btn view-switcher ficon-app-grid"
			data-cy="change-to-grid"
			[matTooltip]="'change-to-grid-view' | translate"
			matTooltipPosition="left"
			(click)="viewStateDataSource.toggleCurrentView()"></button>
		<button *ngIf="currentView === views.GRID"
			type="button"
			class="icon-btn view-switcher ficon-app-list"
			data-cy="change-to-list"
			[matTooltip]="'change-to-list-view' | translate"
			matTooltipPosition="left"
			(click)="viewStateDataSource.toggleCurrentView()"></button>
	</div>

	<div class="filter-content"
		filter-view-content
		*ngIf="!dataSourceZeroState.hasZeroState && !dataSourceZeroState.isLoading"
		(contextmenu)="openMenu($event)">
		<ng-container *ngIf="hasFolders$ | async; else zerostate;">
			<folders-table-view *ngIf="currentView === views.LIST" (goToFolder)="goToFolder($event)">
			</folders-table-view>

			<folders-grid-view *ngIf="currentView === views.GRID" (goToFolder)="goToFolder($event)"></folders-grid-view>
		</ng-container>

		<ng-template #zerostate>
			<folders-zero-state
					(createFolder)="openCreateCoursePanel()"
					(openInvite)="openInviteModal()"
					[canInvite]="canInvite()"
			></folders-zero-state>
		</ng-template>

		<menu *ngIf="canInvite() || canCreateCourse()">
			<org-context-menu
				[canInvite]="canInvite()"
				[canCreateCourse]="canCreateCourse()"
				(onInvite)="openInviteModal()"
				(onCreateCourse)="openCreateCoursePanel()"></org-context-menu>
		</menu>
	</div>

	<!-- Datasource zero state -->
	<div class="filter-zero-state" filter-view-content [hidden]="!dataSourceZeroState.hasZeroState && !dataSourceZeroState.isLoading">
		<data-source-zero-state [dataSource]="folderListDataSource" (zeroStateChanged)="zeroStateChanged($event)"></data-source-zero-state>
	</div>

	<div class="filter-action" filter-view-action-bar [hidden]="dataSourceZeroState.hasZeroState">
		<div class="btn-wrapper" *ngIf="hasFolders$ | async">
			<button class="create-course-btn primary-btn"
				*ngIf="canCreateCourse()"
				(click)="openCreateCoursePanel()"
				data-cy="create-course"
				[disabled]="isCreating$ | async"
				translate>
				folders_view-create_button
				<i *ngIf="isCreating$ | async" class="ficon-spinner ficon-spin" aria-live="polite" attr.aria-label="{{'common_loading'| translate}}"></i>
			</button>
		</div>
	</div>

</filter-view-layout>
